export default __webpack_public_path__ + "static/media/pdf_icon.487c1d2c.png";